import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useShareActions } from '#src/app/shared/hooks/share';
import type { ShareAction, ShareActionsOptions } from '#src/app/shared/hooks/share';

import { useShareOptions } from './options';
import { useOnShareSuccess } from './success';

type Result = {
	shareActions: readonly ShareAction[];
	/**
	 * The options the share actions were built with. Returned so that a share which runs outside the
	 * pipeline (the Facebook post sheet's CTA) reuses the same `onSuccess`, and with it the same
	 * `useRedirect` instance: each instance owns its own copy-link redirect timer.
	 */
	shareOptions: ShareActionsOptions;
	// EXPERIMENT: psf_promote_or_share_qr_code_experiment — remove with experiment cleanup
	/** Redirects to the share page after a QR Save or Print, from the same `useRedirect` instance. */
	redirectAfterQrShare: ReturnType<typeof useOnShareSuccess>['redirectAfterQrShare'];
	/** Cancels a pending QR download redirect, on the same `useRedirect` instance. */
	cancelQrRedirect: ReturnType<typeof useOnShareSuccess>['cancelQrRedirect'];
};

export function usePsfShareAvailableShareActions(): Result {
	const { onSuccess, onShareTapped, redirectAfterQrShare, cancelQrRedirect } = useOnShareSuccess();
	const shareOptions = useShareOptions({ onSuccess, onShareTapped });
	const {
		data: {
			petition: { shareLinks },
		},
	} = usePsfPromoteOrSharePageData();

	return {
		shareActions: useShareActions(shareLinks.links, shareOptions),
		shareOptions,
		redirectAfterQrShare,
		cancelQrRedirect,
	};
}
